import {
  AccountInfo,
  Configuration,
  EventType,
  PublicClientApplication,
} from '@azure/msal-browser';


const createMsalConfig = (): Configuration => ({
  auth: {
    clientId: import.meta.env.VITE_MSAL_CLIENT_ID,
    authority: import.meta.env.VITE_MSAL_AUTHORITY,
    navigateToLoginRequestUrl: false,
    redirectUri: import.meta.env.VITE_MSAL_REDIRECT_URI,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    asyncPopups: true,
    navigateFrameWait: 0,
    redirectNavigationTimeout: 60,
    allowRedirectInIframe: true,
  },
});

export const createMsalInstance = async (): Promise<PublicClientApplication> => {
  const msalInstance = new PublicClientApplication(createMsalConfig());
  await msalInstance.initialize();
  msalInstance.enableAccountStorageEvents();

  msalInstance.addEventCallback((event) => {
    if (event.eventType === EventType.LOGIN_SUCCESS) {
      const account = event.payload as AccountInfo;
      msalInstance.setActiveAccount(account);
    }
  });

  return msalInstance;
};
